export const enum FlagKeys {
  DATA_VIS = 'ca-my-bayer-data-visualization',
  EVENT_PASS = 'ca-my-bayer-outdoor-show-pass',
  SUMMER_SIZZLER = 'ca-my-bayer-summer-sizzler-banner',
}
